var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoMoreAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.405,
    height: 69.691,
    viewBox: "0 0 76.405 69.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161036",
    "data-name": "Group 161036",
    transform: "translate(2.581 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38798",
    "data-name": "Path 38798",
    d: "M45.073,18.244,15.828,70.2a6.367,6.367,0,0,0,5.548,9.491H79.867A6.367,6.367,0,0,0,85.416,70.2L56.171,18.244A6.367,6.367,0,0,0,45.073,18.244Z",
    transform: "translate(-15 -15)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    y2: 27.222,
    transform: "translate(35.772 17.568)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    transform: "translate(35.772 54.037)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMoreAlert);
export default __webpack_public_path__ + "static/media/No-More-Alert.0ae558267fe48a0bb19909647b183853.svg";
export { ForwardRef as ReactComponent };